export default __webpack_public_path__ + "static/media/Brief-orange.e3f0a7e4.svg";